import { ws } from "../../utils/common";

export const getUnusedActivationCodeWS = async () => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "activation-code/",
    null,
    null,
    true
  );

  if (res.error) {
    throw res.data.message;
  } else {
    return res.data;
  }
};

export const codeGeneratorWS = async ({ name }) => {
  const res = await ws(
    "POST",
    process.env.REACT_APP_ENDPOINT + "activation-code/",
    null,
    { name },
    true
  );

  if (res.error) {
    throw res.data.message;
  } else {
    return res.data;
  }
};
